function EmailFactory() {
  class Email {
    constructor() {
      this.from = null;
      this.to = [];
      this.body = null;
      this.attachPDF = true;
    }

    setFrom(name, email) {
      this.from = { name, email };
    }

    addTo(name, email, type) {
      this.to.push({ name, email, type });
    }
  }

  return Email;
}

export default EmailFactory;
